import React from 'react';
import PropTypes from 'prop-types';

const RecommendationsItemSkeleton = ({ isVideo }) => (
  <div
    className={`skeleton-item recommendations-item-skeleton ${
      isVideo ? '--video' : ''
    }`}
  >
    <div className="skeleton-item__body">
      <div className="skeleton-item__media"></div>
      <div className="skeleton-item__content">
        <div className="skeleton-item__title"></div>
        <div className="skeleton-item__tag"></div>
      </div>
    </div>
  </div>
);

RecommendationsItemSkeleton.propTypes = {
  isVideo: PropTypes.bool.isRequired,
};

RecommendationsItemSkeleton.defaultProps = {};

export default RecommendationsItemSkeleton;
